import { Component, OnInit,Inject } from '@angular/core';

import { SellerService } from '../core';
import {  MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PopupMessageService } from '../shared/message/services/message.service';
import { ManageActivitiesComponent } from '../home/manage-activities/manage-activities.component';
import { SellerRewardsDialogComponent } from '../shared';

@Component({
  selector: 'app-welcomepage-dialog',
  templateUrl: './welcomepage-dialog.component.html',
  styleUrls: ['./welcomepage-dialog.component.scss']
})
export class WelcomepageDialogComponent implements OnInit {

  popupName:string;

  constructor(
  
    @Inject(MAT_DIALOG_DATA) public data,
 
) { 
  }

  ngOnInit() {
    this.popupName=this.data.data;
    // console.log(this.data)
  }


}
